import React, { useState } from 'react'
import { EFinancingUxFeedbackModal } from './constants'
import { FinancingUxFeedbackModalError } from './FinancingUxFeedbackModalError'
import { FinancingUxFeedbackModalForm } from './FinancingUxFeedbackModalForm'
import { FinancingUxFeedbackModalSuccess } from './FinancingUxFeedbackModalSuccess'
import type { IFinancingUxFeedbackModalProps } from './types'
import './styles.scss'

export const FinancingUxFeedbackModal = (props: IFinancingUxFeedbackModalProps) => {
  const { isHasSkipButton, onSkipAction, onCustomSuccessAction } = props.options

  const [isActiveStep, setIsActiveStep] = useState<EFinancingUxFeedbackModal>(EFinancingUxFeedbackModal.FORM)

  const goToSuccessStep = () => (onCustomSuccessAction ? onCustomSuccessAction() : setIsActiveStep(EFinancingUxFeedbackModal.SUCCESS))
  const goToErrorStep = () => setIsActiveStep(EFinancingUxFeedbackModal.ERROR)

  switch (isActiveStep) {
    case EFinancingUxFeedbackModal.SUCCESS:
      return <FinancingUxFeedbackModalSuccess />
    case EFinancingUxFeedbackModal.ERROR:
      return <FinancingUxFeedbackModalError />
    default:
    case EFinancingUxFeedbackModal.FORM:
      return (
        <FinancingUxFeedbackModalForm
          onSuccess={goToSuccessStep}
          onError={goToErrorStep}
          isHasSkipButton={isHasSkipButton}
          onSkipAction={onSkipAction}
          onCustomSuccessAction={onCustomSuccessAction}
        />
      )
  }
}
